import Component from '@glimmer/component';

interface UiSwitchLabelSignature {
  Element: HTMLElement;
  Args: {
    Named: {
      guid: string;
      onClick: () => void;
    };
  };
  Blocks: {
    default: [];
  };
}

export default class UiSwitchLabelComponent extends Component<UiSwitchLabelSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Switch::Label': typeof UiSwitchLabelComponent;
    'ui/switch/label': typeof UiSwitchLabelComponent;
  }
}
